import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

export async function getInTransitList() {
  const res = await axios.get(`${API}/dispatch/in-transit`, { headers: authHeader() });
  return res.data;
}

export async function getInTransitDetail(appointmentId) {
  const res = await axios.get(
    `${API}/dispatch/in-transit-detail/${appointmentId}`,
    { headers: authHeader() }
  );
  return res.data;
}
